import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import PropTypes from "prop-types";
import Odometer from "react-odometerjs";

import { currencyFormat } from "@lib/text.helpers";

import "./salary-display.scss";

export const SalaryDisplay = ({ salary = 0, adjustmentAmount }) => {
  return (
    <div className="salary-display">
      <motion.div
        className={clsx("salary-amount", {
          increase: adjustmentAmount > 0,
          deduct: adjustmentAmount < 0,
        })}
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        $
        <Odometer value={salary} format="(,ddd)" duration={250} />
        <span className="salary-amount-frequency-separator">|</span>mo
      </motion.div>

      <div className="adjustment-amount-container">
        <AnimatePresence>
          {adjustmentAmount && (
            <motion.div
              className={clsx("adjustment-amount", {
                increase: adjustmentAmount > 0,
                deduct: adjustmentAmount < 0,
              })}
              initial={{ opacity: 0, y: "1.25rem" }}
              animate={{
                opacity: 1,
                y: 0,
                transition: { type: "spring", bounce: 0.5, duration: 0.3 },
              }}
              exit={{ opacity: 0, y: "-1.25rem" }}
            >
              {adjustmentAmount > 0 && "+"}
              {currencyFormat(adjustmentAmount)}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

SalaryDisplay.propTypes = {
  salary: PropTypes.number,
  adjustmentAmount: PropTypes.number,
};
